import loadable from '@loadable/component';
import categoryPageQuery from './query.graphql';

const Category = loadable(() =>
  import(/* webpackChunkName: "category" */ './category')
);

Category.graphQL = categoryPageQuery;

Category.loadOrder = [
  { main: true, products: true },
  { campaigns: true, newReleases: true },
];

Category.variables = ({
  id,
  offset,
  campaignId,
  filterId,
  sort,
  direction,
  brand,
  compare,
}) => ({
  id,
  offset: parseInt(offset, 10) || 0,
  campaignId,
  categoryDealId: [id],
  filterId,
  sort,
  direction,
  brand,
  compareIds: compare ? compare.split(',') : ['_core_'],
});

Category.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => key === 'id' || key === 'brand' || key === 'filterId')
        .filter(key => variables[key])
        .map(key => variables[key])
    : [];

  return `${name}_${groupVariables.join('_')}_${variables.compareIds.join(
    ':'
  )}`;
};

export default Category;
